"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var muiThemeable_1 = __importDefault(require("material-ui/styles/muiThemeable"));
var recompose_1 = require("recompose");
var Item = function (_a) {
    var item = _a.item, index = _a.index, length = _a.length;
    return (react_1.default.createElement("span", null,
        item.label,
        " ",
        index < length - 1 && react_1.default.createElement("span", null, "/\u00A0")));
};
var Breadcrumbs = function (_a) {
    var breadcrumbs = _a.muiTheme.breadcrumbs, items = _a.items, ItemComponent = _a.ItemComponent;
    var length = items.length;
    return (react_1.default.createElement("h1", { style: breadcrumbs, className: "hidden-for-print" }, items.map(function (item, index) { return (react_1.default.createElement(ItemComponent, { key: item.label, item: item, index: index, length: length })); })));
};
exports.default = recompose_1.compose(recompose_1.defaultProps({ ItemComponent: Item }), muiThemeable_1.default())(Breadcrumbs);
//# sourceMappingURL=Breadcrumbs.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/app/Breadcrumbs.js
// module id = 1866
// module chunks = 0